var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list',{attrs:{"fs":_vm.couponFields,"api":"coupons","editLink":"/admin/coupons","addLink":"/admin/coupons/new"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }